/* sv-ownart 0.43.1: "Use our design" or "Upload your own" on every one-design personalised product.
   Pairs with snippets/sv-ownart.liquid. Design mode changes nothing: our inputs carry no name and no form=.
   Upload mode names them, ties them to the product form with form=, marks the form data-sv-native so sv-multi
   stands aside, and Horizon's own add posts the form as multipart, file included. */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function boot(root) {
    var MIN = parseInt(root.dataset.min, 10) || 1500, MAX = parseInt(root.dataset.max, 10) || 8000;
    var WHAT = root.dataset.what || 'item';
    var perso = root.closest('.sv-perso') || document;
    var panel = $('[data-own-panel]', root), file = $('[data-own-file]', root);
    var thumb = $('[data-own-thumb]', root), timg = $('[data-own-timg]', root), dims = $('[data-own-dims]', root);
    var why = $('[data-own-why]', root), rights = $('[data-own-rights]', root), need = $('[data-own-need]', root);
    var qEl = $('[data-own-q]', root), cta = $('[data-own-cta]', root), dname = $('[data-own-dname]', root);
    var prop = {}; $$('[data-own-prop]', root).forEach(function (i) { prop[i.dataset.ownProp] = i; });
    var st = { mode: 'design', ok: false, url: '', w: 0, h: 0 };
    var saved = null, step2 = $('.sv-perso__step--2', perso), step2txt = step2 ? step2.innerHTML : '';

    function form() {
      return document.querySelector('form[action*="/cart/add"][id^="BuyButtons-ProductForm"]') ||
             document.querySelector('main form[action*="/cart/add"]');
    }
    /* f.id would be the form's hidden <input name="id"> (the variant), not its id attribute. */
    function name1() { return $('.sv-item .sv-name', perso) || $('#sv-name-1'); }
    function ours() { return $$('[data-n]', root); }

    /* Hide what only makes sense for our designs: the design grid, the number chips (each chip builds a row
       with its own design), the family hint, the per-row Change design and the running total of the chips. */
    function offList() {
      var l = $$('.sv-sw, .sv-qty, .sv-mbsum, .sv-perso__step--1, .sv-item__chg, .sv-set', perso);
      var s1 = $('.sv-perso__step--1', perso), h = s1 && s1.nextElementSibling;
      if (h && h.classList.contains('sv-perso__hint')) l.push(h);
      return l;
    }
    function renum() {
      var n = 0;
      $$('.sv-perso__step', perso).forEach(function (p) {
        if (p.closest('[hidden]') || p.closest('.sv-own-off') || p.classList.contains('sv-own-off')) return;
        var sp = p.querySelector('span'); if (sp) sp.textContent = String(++n);
      });
    }
    function art() { return $('.sv-item .sv-preview2__art', perso) || $('.sv-preview2__art', perso); }
    function showArt() {
      var a = art(); if (!a) return;
      if (st.mode === 'upload' && st.ok && st.url) {
        if (!saved) saved = { src: a.getAttribute('src'), srcset: a.getAttribute('srcset') };
        a.removeAttribute('srcset'); a.src = st.url;
      } else if (saved) {
        a.src = saved.src; if (saved.srcset) a.setAttribute('srcset', saved.srcset);
        saved = null;
      }
    }

    function wire(on) {
      var f = form(); if (!f) return;
      ours().forEach(function (e) {
        if (on) { e.setAttribute('name', e.dataset.n); e.setAttribute('form', f.getAttribute('id')); }
        else { e.removeAttribute('name'); e.removeAttribute('form'); }
      });
      var nm = name1(); if (nm) { if (on) nm.setAttribute('form', f.getAttribute('id')); else nm.removeAttribute('form'); }
      if (on) { f.setAttribute('enctype', 'multipart/form-data'); f.setAttribute('data-sv-native', '1'); }
      else f.removeAttribute('data-sv-native');
    }

    function setMode(m) {
      st.mode = m;
      $$('[data-own-mode]', root).forEach(function (b) {
        var on = b.dataset.ownMode === m;
        b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      if (m === 'upload') {
        var one = $('.sv-qty__b[data-q="1"]', perso);
        if (one && !one.classList.contains('is-on')) one.click();
        panel.hidden = false;
        offList().forEach(function (e) { e.classList.add('sv-own-off'); });
        if (step2) step2.innerHTML = step2txt.replace(/Name for each,?/i, 'Name,').replace(/Design and name for each/i, 'Name');
      } else {
        panel.hidden = true;
        $$('.sv-own-off', perso).forEach(function (e) { e.classList.remove('sv-own-off'); });
        if (step2) step2.innerHTML = step2txt;
      }
      wire(m === 'upload'); showArt(); renum(); gate();
    }

    function bad(msg) { why.textContent = msg; why.hidden = !msg; }
    function measure() {
      st.ok = false; st.w = st.h = 0; prop.size.value = '';
      var fl = file.files && file.files[0];
      if (st.url) { try { URL.revokeObjectURL(st.url); } catch (e) {} st.url = ''; }
      if (!fl) { thumb.hidden = true; bad(''); cta.textContent = 'Choose your image'; showArt(); gate(); return; }
      cta.textContent = 'Change image';
      if (!/^image\/(jpeg|png)$/.test(fl.type)) {
        thumb.hidden = true; bad('Please choose a JPEG or PNG. This file is ' + (fl.type || 'a type we cannot print') + '.');
        showArt(); gate(); return;
      }
      if (fl.size > 20 * 1024 * 1024) {
        thumb.hidden = true; bad('This file is ' + (fl.size / 1048576).toFixed(1) + ' MB. The limit is 20 MB. Save a smaller copy and choose that.');
        showArt(); gate(); return;
      }
      st.url = URL.createObjectURL(fl);
      var im = new Image();
      im.onload = function () {
        st.w = im.naturalWidth; st.h = im.naturalHeight;
        var longS = Math.max(st.w, st.h);
        timg.src = st.url; thumb.hidden = false;
        if (longS < MIN) {
          dims.textContent = st.w + ' x ' + st.h + ' pixels';
          bad('This image is ' + st.w + ' x ' + st.h + ' pixels. For a sharp print on this ' + WHAT + ' we need at least ' + MIN +
              ' on the longest side, or it will print blurry. Try the original from your camera roll, not a copy saved from social media or a message.');
        } else if (longS > MAX) {
          dims.textContent = st.w + ' x ' + st.h + ' pixels';
          bad('This image is ' + st.w + ' x ' + st.h + ' pixels, larger than we can take (' + MAX + ' on the longest side). Save a smaller copy and choose that.');
        } else {
          st.ok = true; bad('');
          dims.innerHTML = '<strong>Looks good.</strong> ' + st.w + ' x ' + st.h + ' pixels, sharp enough for this ' + WHAT + '.';
          prop.size.value = st.w + ' x ' + st.h + ' px, checked in the shop against the ' + MIN + ' px minimum';
        }
        showArt(); gate();
      };
      im.onerror = function () {
        thumb.hidden = true; bad('We could not open this image. Please choose a JPEG or PNG.'); showArt(); gate();
      };
      im.src = st.url;
    }

    function ready() { return st.mode !== 'upload' || (st.ok && rights.checked); }
    function gate() {
      var f = form(); if (!f) return;
      var b = f.querySelector('[type="submit"][name="add"], button[name="add"]');
      if (!b) return;
      if (st.mode === 'upload') {
        b.toggleAttribute('data-own-hold', !ready());
        b.setAttribute('aria-disabled', ready() ? 'false' : 'true');
      } else { b.removeAttribute('data-own-hold'); b.removeAttribute('aria-disabled'); }
    }

    $$('[data-own-mode]', root).forEach(function (b) {
      b.addEventListener('click', function () { setMode(b.dataset.ownMode); });
    });
    file.addEventListener('change', measure);
    rights.addEventListener('change', function () {
      need.hidden = true;
      prop.rights.value = rights.checked ? 'Customer confirmed they own this image or have permission to print it' : '';
      gate();
    });
    function clampQ() { var v = parseInt(qEl.value, 10); if (!(v >= 1)) v = 1; if (v > 20) v = 20; qEl.value = v; }
    $('[data-own-minus]', root).addEventListener('click', function () { qEl.value = (parseInt(qEl.value, 10) || 1) - 1; clampQ(); });
    $('[data-own-plus]', root).addEventListener('click', function () { qEl.value = (parseInt(qEl.value, 10) || 1) + 1; clampQ(); });
    qEl.addEventListener('change', clampQ);

    /* Runs in the capture phase on document, after sv-multi's (registered earlier), before Horizon's form
       listener. sv-multi returns at once on a data-sv-native form. */
    document.addEventListener('submit', function (e) {
      if (st.mode !== 'upload') return;
      var f = form(); if (!f || e.target !== f) return;
      var msg = '';
      if (!file.files || !file.files[0]) msg = 'Choose your image first.';
      else if (!st.ok) msg = why.textContent || 'This image cannot be printed well. Choose another.';
      else if (!rights.checked) { need.hidden = false; msg = 'Tick the box to confirm you have the rights to this image.'; }
      if (msg) {
        e.preventDefault(); e.stopImmediatePropagation();
        if (!why.textContent || msg !== why.textContent) bad(msg);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      wire(true); clampQ();
      var nm = name1(), fc = $('.sv-item input[name^="sv-face"]:checked', perso);
      prop.face.value = (nm && nm.value.trim() && fc) ? fc.value : '';
      if (!prop.face.value) prop.face.removeAttribute('name');
    }, true);

    /* Keep the design card's name in step with the design grid (Show all can switch design). */
    var now = $('[data-sw-now]', perso);
    if (now && dname) new MutationObserver(function () { if (now.textContent.trim()) dname.textContent = now.textContent.trim(); })
      .observe(now, { childList: true, characterData: true, subtree: true });

    /* sv-multi rebuilds rows (and the preview) when the variant changes; keep the upload in the preview. */
    var pend = false;
    new MutationObserver(function () {
      if (pend || st.mode !== 'upload') return; pend = true;
      setTimeout(function () {
        pend = false; var a = art();
        if (a && st.ok && st.url && a.src !== st.url) { saved = null; showArt(); }
        var nm = name1(), f = form(); if (nm && f && nm.getAttribute('form') !== f.getAttribute('id')) nm.setAttribute('form', f.getAttribute('id'));
        $$('.sv-item__chg', perso).forEach(function (e) { e.classList.add('sv-own-off'); });
        gate();
      }, 60);
    }).observe(perso, { childList: true, subtree: true });

    renum();
    try {
      var qs = new URLSearchParams(location.search);
      if (qs.get('art') === 'upload') setMode('upload');
      /* 0.44.2: the builder's Upload your own card carries the typed name across. */
      var qn = qs.get('name'), n1 = name1();
      if (qn && n1 && !n1.value) { n1.value = qn.slice(0, parseInt(n1.getAttribute('maxlength'), 10) || 20); n1.dispatchEvent(new Event('input', { bubbles: true })); }
    } catch (e) {}
  }

  function start() {
    $$('[data-sv-own]').forEach(function (r) { if (!r.dataset.svOn) { r.dataset.svOn = '1'; boot(r); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
